module.exports = __webpack_public_path__ + "img/logo_marginx.75ee4291.png";